<script setup lang="ts">
import { useTitle } from '@vueuse/core';
import { services } from '@layouts/constant';

const error = useError();
let statusCode = 500;
if (error && (error.value as any).statusCode) {
    ({ statusCode } = error.value as any);
}
useRobots({ noindex: true, nofollow: true });
const siteConfigs = useSiteConfigs();
const title = useTitle();
if (statusCode === 404 || statusCode === 410) {
    title.value = `${'صفحه وجود ندارد'} | ${siteConfigs?.title || 'مِستربلیط'}`;
}
</script>

<template>
    <NuxtLayout name="error">
        <div>
            <div
                v-if="statusCode === 404 || statusCode === 410"
                class="error-container"
            >
                <img
                    src="~/assets/files/errors/404.png"
                    class="error-img"
                    alt="404"
                />
                <div class="not-found-text">
                    {{
                        `این یک صفحه با خطا ${statusCode} است. ممکن است حذف شده باشد.`
                    }}
                </div>
                <mr-button
                    class="home-page-btn"
                    variant="transparent"
                    link="nuxt"
                    href="/"
                >
                    صفحه اصلی
                </mr-button>
            </div>
            <div v-else class="error-container">
                <div class="not-found-text">خطایی رخ داد</div>
                <img
                    src="~/assets/files/errors/500.svg"
                    class="error-img"
                    alt="500"
                />
            </div>
            <MrTypography size="x-small" color="white" class="error-details">
                {{ error }}
            </MrTypography>
            <div class="services">
                <NuxtLink
                    v-for="{ icon, label, href } in services"
                    :key="label"
                    :to="href"
                    rel="nofollow"
                    class="service"
                    prefetch
                >
                    <div class="icon-wrapper">
                        <mr-icon size="x-large" :icon color="var(--blue-400)" />
                    </div>
                    <mr-typography weight="600">{{ label }}</mr-typography>
                </NuxtLink>
            </div>
        </div>
    </NuxtLayout>
</template>

<style scoped lang="scss">
.error-container {
    text-align: center;
    min-height: 400px;
}

.home-page-btn {
    margin-inline: auto;
}

.error-container {
    padding-top: 130px;
}

.services {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    row-gap: 20px;
    padding-top: 10px;
    @include mobile-only {
        grid-template-columns: 1fr 1fr 1fr;
    }
    .service {
        all: unset;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        cursor: pointer;
        .icon-wrapper {
            background-color: white;
            padding: 16px;
            border-radius: 16px;
        }
    }
}

.error-img {
    width: 400px;
    margin: 20px auto 0;
    @include mobile-only {
        width: 250px;
    }
}

.not-found-text {
    line-height: 28px !important;
    font-size: 14px !important;
    color: usePalette($p-gray, $p-600);
    @include font-weight();
    padding-top: 20px;
}

.error-details {
    display: none;
}
</style>
